import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BarChart3, Settings, ArrowRightLeft, Library, PieChart, LayoutGrid, Clock } from "lucide-react";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/partner/portfoliomanagement/mm", icon: BarChart3 },
  { label: "MM Fund Holdings and Weightings", path: "/partner/portfoliomanagement/mm/funds", icon: Settings },
  { label: "Holdings Sector Appropriating", path: "/partner/portfoliomanagement/mm/sector-weightings", icon: PieChart },
  { label: "MM Sector Weightings", path: "/partner/portfoliomanagement/mm/mm-sector-weightings", icon: LayoutGrid },
  { label: "Holdings Duration", path: "/partner/portfoliomanagement/mm/holdings-duration", icon: Clock },
  { label: "Trade Log", path: "/partner/portfoliomanagement/mm/trades", icon: ArrowRightLeft },
  { label: "Investable Universe", path: "/partner/portfoliomanagement/mm/universe", icon: Library },
];

export default function MmBenchmarkLayout() {
  const location = useLocation();
  return (
    <div className="min-h-screen">
      <div className="border-b bg-muted/30 mt-6 pt-2">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-1 h-12 w-full overflow-x-auto">
            {NAV_ITEMS.map((item) => {
              const isActive = item.path === "/partner/portfoliomanagement/mm"
                ? location.pathname === item.path
                : location.pathname === item.path || location.pathname.startsWith(item.path + "/");
              return (
                <Link key={item.path} to={item.path} className={cn(
                  "flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap",
                  isActive ? "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}>
                  <item.icon className="h-4 w-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 py-6"><Outlet /></div>
    </div>
  );
}
